import request from "../utils/request";

var resource = '/resource'
var otc =  '/c2c'
// 活动信息
export function taskCenterActivity() {
    return request({
        url: resource + '/task/center/activity',
        method: 'get'
    })
}

// 任务中心--未登录
export function taskList() {
    return request({
        url: resource + '/task/center/task',
        method: 'get'
    })
}

// 任务中心--已登录
export function taskListLogin() {
    return request({
        url: resource + '/task/center/task/user',
        method: 'get'
    })
}

// 用户上传信息采集
export function infoUpload(data) {
    return request({
        url: resource + '/task/center/toupload',
        method: 'post',
        data
    })
}

// 奖励金额
export function myAward() {
    return request({
        url: resource + '/task/center/award',
        method: 'get',
    })
}

// 领取奖励
export function receiveRewards(data) {
    return request({
        url: resource + '/task/center/receive/award',
        method: 'post',
        data,

    })
}
//  盲盒抽奖
export function blindBoxInfo() {
    return request({
        url: resource + '/blind-box/info',
        method: 'get'
    })
}

// 抽奖数据概览
export function blindSummary() {
    return request({
        url: resource + '/blind-box/summary',
        method: 'get'
    })
}

// 已获得的奖励列表
export function awardsList(data) {
    return request({
        url: resource + '/blind-box/details',
        method: 'get',
        data,
    })
}

// 抽将
export function drawApi() {
    return request({
        url: resource + '/blind-box/draw',
        method: 'post'
    })
}

// 签到活动配置
export function signConfigApi() {
    return request({
        url: resource + '/sign/config',
        method: 'get'
    })
}
//签到活动的签到
export function signApi() {
    return request({
        url: resource + "/sign",
        method: 'post',
    })
}
//签到活动我的奖励
export function mystuff() {
    return request({
        url: resource + "/sign/reward-log",
        method: "get"
    })
}
//签到活动用户签到信息
export function usermsg() {
    return request({
        url: resource + "/sign/sign-info",
        method: "get"
    })
}
//签到活动中奖名单
export function userwind() {
    return request({
        url: resource + '/sign/winner-list',
        method: "get"
    })
}
//获取用户签到记录
export function getsign() {
    return request({
        url: resource + "/sign/sign-log",
        method: "get"
    })
}
//添加用户补签
export function addsign(data) {
    return request({
        url: resource + "/sign/countersign",
        method: "post",
        data: data,
        headers: { 'Content-Type': 'application/json; charset=UTF-8' }
    })
}

//获取类别
export function getcategorys(data) {
    return request({
        url: resource + "/college/article/categorys",
        method: "GET",
        data
    })
}
//获取列表数据

export function getListdata(data) {
    return request({
        url: resource + "/college/articles",
        method: "GET",
        data
    })
}

//获取详情数据
export function getdatadetail(data) {
    return request({
        url: resource + "/college/article/detail",
        method: "GET",
        data
    })
}
//获取视频接口
export function getvediourl() {
    return request({
        url: resource + '/college/video',
        method: 'GET',
    })
}

//获取小组信息
export function getgroupmsg() {
    return request({
        url: resource + "/world-cup/group-stage",
        method: 'GET'
    })
}

//投注
export function Betting(data) {
    return request({
        url: resource + "/world-cup/bets",
        method: "POST",
        data,
        headers: { 'Content-Type': 'application/json; charset=UTF-8' }
    })
}
//投注记录

export function bettingList(data) {
    return request({
        url: resource + "/world-cup/bets",
        method: 'GET',
        data
    })
}
//活动配置信息

export function worldcupconfig() {
    return request({
        url: resource + "/world-cup/config",
        method: 'GET'
    })
}

//获取淘汰赛信息
export function knockoutConfig(data) {
  return request({
    url: resource + "/world-cup/knockout",
    method: 'get',
    data
  })
}

// 获取Banner
export function getBanner(data) {
  return request({
    url: resource + '/banners',
    method: 'get',
    data
  })
}

// 获取公告
export function getNotice(data) {
  return request({
    url: resource + '/notice/news',
    method: 'get',
    data
  })
}

// 新手指导
export function getList() {
  return request({
    url: resource + '/guides',
    method: 'get'
  })
}

// 获取下载版本信息
export function versionsApi() {
  return request({
    url: resource + '/versions/web',
    method: 'get'
  })
}

export function linksApi(data) {
  return request({
    url: resource + '/contacts',
    method: 'get',
    data
  })
}

//获取第三方币种
export function  getCurrency(data){
  return request({
    url: otc + '/v3/public/third-party/currency-list',
    method: 'get',
    data
  })
}
//获取第三方法币
export function getFiat(data){
  return request({
    url: otc + '/v3/public/third-party/fiat-list',
    method: 'get',
    data
  })
}
// 收付款列表
export function  thirdParty_payList(data){
  return request({
    url: otc + '/v3/public/third-party/payment-list',
    method: 'get',
    data
  })
}

//获取支付渠道列表
export function  thirdParty_channelList(data){
  return request({
    url: otc + '/v3/public/third-party/supplier-list',
    method: 'get',
    data
  })
}
export function  placeAnOrder(data){
  return request({
    url: otc + '/v3/third-party/order',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json; charset=UTF-8' }
  })
}
//获取用户资产
export  function getUserAmount(data){
  return request({
    url:  '/spot/spot/balance/available',
    method: 'get',
    data,
  })
}

// 现货自由区上币-币种图标上传
export function coinImgUpload(data) {
    return request({
        url: resource + '/v3/upload/ten-img',
        method: 'post',
        data,
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
    })
}


// WEBPACK FOOTER //
// ./src/api/resource.js